<div>
    <div class="text-center mb-5">
        <img width="61" height="60" class="my-3" *ngIf="status === 'success'" src="../../../../assets/resources/web/images/design/ok.png">
        <h3 class="text-uppercase text-bleu-tdm my-2 fw-semibold">{{titile}}</h3>
        <h4 class="fw-bolder">{{message}}</h4>
        <h5 [innerHtml]="description"></h5>
        <div class="my-3" role="button" (click)="home()">
            <span class="text-black fw-bolder">
                Revenir à l’accueil<i style="color: #00579C;" class="bi bi-arrow-right mx-2  h4"></i></span>
        </div>
    </div>
    <div class="m-1 m-md-3">
        <div class="card card-gris border-0">
            <div class="row p-3">
                <div class="col-md-3 col-sm-12 bg-bloc mb-2 mb-md-0">
                </div>
                <div class="col-md-9 col-sm-12 text-md-start text-center ">
                    <h5 class="fw-bolder">Accédez à votre compte personnel THE DOOR MAN</h5>
                    <span>Pour retrouver vos biens en vente, vos prochaines visites et tous vos documents !</span>
                    <div class="my-3">
                        <button [routerLink]="['/connexion']" routerLinkActive="router-link-active"
                                *ngIf="!userConnected" (click)="closeModal()"
                                type="submit" class="btn btn btn-outline-primary me-3 my-2">
                                Se connecter
                        </button>
                        <button [routerLink]="['/amis-tdm/liste']" routerLinkActive="router-link-active"
                                *ngIf="!userConnected" (click)="closeModal()"
                                type="submit" class="btn btn btn-outline-primary me-3 my-2">
                                Trouver mon Conseiller
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
